import { useI18n as useI18nNative, type UseI18nOptions } from 'vue-i18n';
import type { MessageSchema, SupportedLanguage } from 'src/plugins/i18n';

type Options = UseI18nOptions<{ message: MessageSchema }, SupportedLanguage>;

/**
 * Wrapper around vue-i18n's `useI18n` with the correct typescript type for the translation schema
 * @returns VueI18n instance
 */
export function useI18n(config?: Options) {
  return useI18nNative<Options>(config);
}

export default useI18n;
